module.exports = __webpack_public_path__ + "static/how-to-change-your-mind-6f814c4d5cf221218688b92099cda9a4.jpg";